<template>
  <Popup :header="''" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>
      {{ text }}
    </template>
    <template v-slot:accept-btn-label> Versenden </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';

export default {
  name: 'FragebogenVersendenPopup',
  components: { Popup },
  props: {
    text: {
      type: String,
      default: 'Soll der Fragebogen wirklich versendet werden?',
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('cancel');
    },
    acceptAndClose() {
      this.$emit('versenden');
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
